import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'
import { formatUsd } from '@/utils/moneyFormat'

export default class ApplicationChatMessage extends AbstractChatMessage {
  body: string = ''
  budget?: number
  deadline?: number
  type = MessageTypes.TEXT
  comment: string

  constructor(data: LX.ApplicationChatMessage) {
    super(data)
    this.comment = data.body.comment
    this.budget = data.body.budget
    this.deadline = data.body.deadline
    this.body = this.budget || this.deadline ? `${data.body.comment}\n` : data.body.comment
    if (this.budget) {
      this.body = `${this.body}\nProposed budget: $${this.budget ? formatUsd(this.budget) : 'Not specified'}`
    }
    if (this.deadline) {
      this.body = `${this.body}\nProposed deadline in days: ${this.deadlineInDays || 'Not specified'}`
    }
  }

  static fromServer(data: LX.ApplicationChatMessage) {
    return new ApplicationChatMessage({ ...data, body: data.body })
  }

  getShortMessage() {
    return this.comment || 'New application'
  }

  get deadlineInDays() {
    return (this.deadline || 0) / 86400
  }
}
